function format (num) {
  return new Intl.NumberFormat('en-US', { style: 'decimal' }).format(num)
}

export default {
  format
}
